var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-form mb-16"},[_c('v-img',{attrs:{"src":_vm.url,"height":_vm.height,"width":_vm.width,"alt":_vm.loadErr},on:{"error":_vm.handleImgError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }